// Accès à la fonctionnalité « État des lieux ».
//
// FAIL-CLOSED : par défaut PERSONNE n'y a accès. L'accès est ouvert dans ces cas :
//  1. l'e-mail est dans l'allowlist de sécurité (comptes internes) — toujours ;
//  2. le compte fait partie du PILOTE historique (empreintes anonymes edlPilotHashes :
//     ~92 clients les plus actifs + pilotes nommés par Charly, lancement 10/07) ;
//  3. le compte est un ABONNÉ PAYANT ACTIF — ouverture générale décidée par Charly le
//     15/07/2026 (même règle que l'assistant chat, cf chatAssistantAccess.js) ;
//  4. sinon, filet de secours : le compte tombe dans le pourcentage de rollout éventuel
//     (VITE_APP_EDL_ROLLOUT_PERCENT), via un découpage DÉTERMINISTE et STABLE.
//
// Les comptes gratuits ne voient donc PAS la fonctionnalité (cas 3 = payants seulement).
import { config } from '@/core/config'
import { isEdlPilot } from './edlPilotHashes'

// Allowlist de sécurité : ces comptes ont TOUJOURS accès (pilotes internes), quel que soit
// le pourcentage.
const EDL_ALLOWLIST = ['charly.leggeri@limeare.com', 'axel@horiz.io', 'janani@horiz.io']

// E-mail de connexion (Keycloak), en minuscules. '' si non lisible -> non autorisé.
function getCurrentEmail() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  if (!tp) return ''

  return (tp.email || (tp.rl_profile && tp.rl_profile.username) || '').trim().toLowerCase()
}

// Identifiant STABLE du compte (Keycloak rl_profile.id, repli sub) : sert au découpage
// déterministe du rollout, un même compte reste toujours dans le même seau.
function getCurrentUserId() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  if (!tp) return ''

  return String((tp.rl_profile && tp.rl_profile.id) || tp.sub || '')
}

// Client PAYANT ACTIF (règle identique à l'assistant chat, cf chatAssistantAccess.js) :
// plan renseigné, différent de 'free'/'no-plan', ET subscribed=true. Keycloak sérialise
// 'subscribed' en booléen OU en chaîne 'true' selon le flux : on accepte les deux formats.
function isCurrentUserPayingClient() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  const rl = (tp && tp.rl_profile) || {}
  const plan = (rl.plan || '').trim().toLowerCase()
  const subscribed = rl.subscribed === true || rl.subscribed === 'true'

  return !!plan && plan !== 'free' && plan !== 'no-plan' && subscribed
}

// Hash déterministe (djb2) -> seau 0..99. Monotone : augmenter le pourcentage n'exclut
// jamais un compte déjà inclus (les seaux < seuil restent < seuil).
function rolloutBucket(key) {
  let h = 5381
  for (let i = 0; i < key.length; i++) {
    h = (h * 33) ^ key.charCodeAt(i)
  }

  return (h >>> 0) % 100
}

// Étape 4 (comparaison entrée/sortie) : null = OUVERT À TOUS (décision Charly
// 21/07/2026, après pilote 2 comptes validé). Le serveur applique le MÊME réglage
// (EDL_COMPARAISON_ALLOWED_EMAILS dans hz-workspace) sur le rattachement edlEntreeId,
// dont découlent le rappel de l'éditeur et le PDF comparé. Pour restreindre à
// nouveau : remettre un tableau d'e-mails des DEUX côtés et redéployer.
const EDL_ETAPE4_ALLOWLIST = null

export function isEdlComparaisonEnabled() {
  if (!EDL_ETAPE4_ALLOWLIST) return true
  const email = getCurrentEmail()

  return !!email && EDL_ETAPE4_ALLOWLIST.includes(email)
}

export function isEdlEnabled() {
  const email = getCurrentEmail()
  if (email && EDL_ALLOWLIST.includes(email)) {
    return true
  }

  // Pilote : empreinte anonyme de l'e-mail OU du username Keycloak.
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  const username = (tp && tp.rl_profile && tp.rl_profile.username) || ''
  if (isEdlPilot(email) || isEdlPilot(username)) {
    return true
  }

  // Ouverture générale : tous les abonnés payants actifs (décision Charly 15/07/2026).
  if (isCurrentUserPayingClient()) {
    return true
  }

  const percent = config.edl.rolloutPercent
  if (!percent) {
    return false
  }
  const uid = getCurrentUserId()
  if (!uid) {
    return false
  }

  return rolloutBucket('edl:' + uid) < percent
}
